export const mainMenuText = 'Menu Principal'
export const notificationsText = 'Notificaciones'
export const selectChildText = 'Seleccionar institución'
export const schoolText = 'Colegio'
export const representativeText = 'Representantes'
export const committeeText = 'Comité'
export const updateDataText = 'Actualizar datos'
export const signOffText = 'Cerrar sesión'
